module.exports = __webpack_public_path__ + "static/media/background.3c9a1ce5.svg";